module.exports = __webpack_public_path__ + "img/arrow_down_circle.dd79ec59.svg";